import { useMediaQuery } from '@mantine/hooks'
import isNull from 'lodash/isNull'

import styles from './CourseHero.module.scss'

interface ICourseHero {
  title: string
  subTitle: string
  heroImg: {
    sm: string
    md: string
    lg: string
  }
  textColor: string | null
}

const CourseHero = ({ title, subTitle, heroImg, textColor }: ICourseHero) => {
  const isLaptop = useMediaQuery('(min-width: 768px) and (max-width: 1023px)')
  const isTablet = useMediaQuery('(max-width: 767px)')
  const { sm, md, lg } = heroImg
  const getBgImg = () => {
    if (isTablet) {
      return sm
    }

    if (isLaptop) {
      return md
    }

    return lg
  }
  return (
    <div
      className={`mx-auto max-w-screen-2xl ${styles.HeroWrap}`}
      style={{ backgroundImage: `url(${getBgImg()})` }}>
      <div className="mx-4 hidden h-full max-w-7xl flex-col justify-center md:flex xl:mx-auto xl:px-6">
        <h2
          className={`mb-4 font-bold ${styles.HeroTitle} break-words`}
          style={!isNull(textColor) ? { color: `${textColor}` } : {}}>
          {title}
        </h2>
        <p
          className={`${styles.HeroSubTitle}`}
          style={!isNull(textColor) ? { color: `${textColor}` } : {}}>
          {subTitle}
        </p>
      </div>
    </div>
  )
}

export default CourseHero
